export default {
  mallAuth: {
    method: 'post',
    url: '/shop/updateShopAuth',
    desc: '店铺授权'
  },
  initData: {
    method: 'post',
    url: '/shop/getShopAuthList',
    desc: '数据初始化'
  },
  shopAdStatus: {
    method: 'post',
    url: '/shopAdStatus',
    desc: '店铺授权状态'
  },
  upAdStatus: {
    method: 'post',
    url: '/upAdStatus',
    desc: '店铺二次授权'
  },
  addShopAuth: {
    method: 'post',
    url: '/shop/add',
    desc: '店铺授权'
  },
  rename: {
    method: 'post',
    url: '/shop/rename',
    desc: '修改店铺名称'
  },
  listSyncShop: {
    method: 'post',
    url: '/listSyncShop',
    desc: '店铺初始化任务列表'
  }
}
